'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Chinese = require('./Chinese.cjs');
var Korean = require('./Korean.cjs');
var Vietnamese = require('./Vietnamese.cjs');
var Japanese = require('./Japanese.cjs');



exports.CalendarChinese = Chinese;
exports.CalendarKorean = Korean;
exports.CalendarVietnamese = Vietnamese;
exports.CalendarJapanese = Japanese;
